import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "reset-password-form" }
const _hoisted_2 = { class: "mt-10" }
const _hoisted_3 = { class: "mt-8" }
const _hoisted_4 = { class: "mt-6 block" }
const _hoisted_5 = {
  key: 1,
  class: "mt-8 text-center"
}
const _hoisted_6 = { class: "w-16 h-16 text-green-500 mb-6 mx-auto" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl font-bold leading-9 tracking-tight text-gray-900" }, "Check your email", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-6 text-gray-500" }, "Your password reset has been sent.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AuthModuleTitle = _resolveComponent("AuthModuleTitle")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_GenproxButton = _resolveComponent("GenproxButton")!
  const _component_GenproxDivider = _resolveComponent("GenproxDivider")!
  const _component_CheckCircle = _resolveComponent("CheckCircle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isRequestSent)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_AuthModuleTitle, { title: "Reset your password" }, {
            default: _withCtx(() => [
              _createTextVNode(" Enter your email and we'll send you a link to reset your password. ")
            ], undefined, true),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_FormKit, {
              type: "form",
              id: "sendResetPasswordRequest",
              "incomplete-message": false,
              "form-class": "space-y-6",
              actions: false,
              onSubmit: _ctx.sendResetPasswordRequest
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FormKit, {
                  label: "Email address",
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                  type: "email",
                  name: "email",
                  id: "email",
                  validation: "required|email"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", null, [
                  _createVNode(_component_GenproxButton, {
                    class: "w-full",
                    isLoading: _ctx.isLoading,
                    type: "submit"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Reset password")
                    ], undefined, true),
                    _: 1
                  }, 8, ["isLoading"])
                ])
              ], undefined, true),
              _: 1
            }, 8, ["onSubmit"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_GenproxDivider, null, {
                default: _withCtx(() => [
                  _createTextVNode("or")
                ], undefined, true),
                _: 1
              }),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_GenproxButton, {
                  class: "w-full",
                  variant: "white",
                  outline: true,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/auth/login')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Sign in ")
                  ], undefined, true),
                  _: 1
                })
              ])
            ])
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_CheckCircle, { class: "w-full h-full object-contain" })
          ]),
          _hoisted_7,
          _hoisted_8
        ]))
  ]))
}